import type { Partner } from "@expert/shared-types";
import type { Subscription } from "../graphql";
import { useExpertAssistStore } from "./store";
import type { Subscriptions } from "./types";

export const setSessionDetails = (sessionId: string, callSid?: string, partner?: Partner) => {
    useExpertAssistStore.getState().setSessionDetails({ sessionId, callSid: callSid ?? undefined, partner });
};

export const setSubscription = (id: keyof Subscriptions, subscription?: Subscription) => {
    useExpertAssistStore.getState().setSubscription(id, subscription);
};
